module.exports = __webpack_public_path__ + "media/images/icons/house-7f9e4f9cae259d3f5762270391bd931c.png";